<template>
	<div :key="'customFreeComponent' + componentKey">

		<n-delete @closeModal="closeModal"
		          @deleteResource="deleteResource"></n-delete>
		<modal-configure v-show="showModalConfigure"
		                 :key="modalConfigureKey"
		                 @update="updateComponent"></modal-configure>
		<modal-rating v-show="rating.showHideModalRating"
		              v-bind:content="{storeModule:rating.storeModule, questionRate: rating.questionRate, section: rating.section}"></modal-rating>
		<div class="col-md-12"
		     v-show="CHECK_ROLE_CARD(2)">
			<div class="card  abtg__default-card abtg__default-card-border abtg__default-card-color-grey-custom">
				<form @submit.prevent="sendData()"
				      v-if="id>0">
					<div class="card-head">
						<header> {{ $t('custom.label_income') }}</header>
						<div class="abtg__header_popover">
							<popover module="custom"
							         content="income"
							         color="grey"
							         position="right"></popover>
						</div>

						<div class="tools"
						     v-if="id>0">
							<a @click="showDeleteModal()"
							   v-if="thisId"
							   class="btn btn-danger shadow-none abtg__btn-tool ">
								<i class="fas fa-trash-alt"></i>{{$t('valutation.label_delete')}}
							</a>

							<a @click="showHideModalConfigure()"
							   class="btn btn-default      shadow-none abtg__btn-tool">{{$t('valutation.label_configure')}}
							</a>

							<a @click="sendData('export')"
							   style="color:#444446"
							   class="btn btn-default      shadow-none abtg__btn-tool">{{$t('valutation.label_export')}}</a>

							<button type="submit"
							        class=" btn margin-right-10 btn-success float-right  shadow-none abtg__btn-tool">
								{{$t('valutation.label_save')}}
							</button>
							<save-ok v-bind:content="{isItOk: saveOk}"></save-ok>
						</div>
					</div>
					<div class="card-body">

						<div class="row">
							<div class="col-3">
								<h5></h5>
							</div>
							<div class="col-2">
								<h5>{{$t('valutation.label_peggiore')}}
									<a @click="showColumn_3 = !showColumn_3">
										<i class="fas fa-eye"></i>
									</a>
								</h5>
							</div>
							<div class="col-2">
								<h5>{{$t('valutation.label_medio')}}
									<a @click="showColumn_2 = !showColumn_2">
										<i class="fas fa-eye"></i>
									</a>
								</h5>

							</div>

							<div class="col-2">
								<h5>{{$t('valutation.label_migliore')}}
									<a @click="showColumn_1 = !showColumn_1">
										<i class="fas fa-eye"></i>
									</a>
								</h5>
							</div>
							<div class="col-2">
								<h5>{{$t('valutation.label_consuntivo')}}
									<a @click="showColumn_4 = !showColumn_4">
										<i class="fas fa-eye"></i>
									</a>
								</h5>
							</div>

							<div class="col-1">
								<!--action button -->
							</div>

						</div>

						<!--------------------------------------->
						<!-- BLOCK 1 -->
						<!-- ----------------------------------- -->
						<div class="row">
							<div class="col">
								<div class="abtg__paragraph_income">
									{{$t('custom.label_costi')}}
								</div>
							</div>
						</div>
						<div class="row abtg__compact_row-custom  "
						     v-for="(inp,index) in filteredInput(1)"
						     v-if="inp.codice && inp.codice.length > 0">

							<!--------------------------------------->
							<!-- BLOCK 1  AGENZIA ACQUISTO -->
							<!-- ----------------------------------- -->
							<div class="col-3"
							     v-if="inp.codice==='agenzia'">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<div class="abtg__readonly_label">
										<strong class="abtg__readonly">{{$t('custom.label_agenzia_acquisto')}}</strong>
										<popover module="custom"
										         content="incomefreeAgency"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</div>
								</div>
							</div>
							<div v-if="inp.codice==='agenzia'"
							     class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_3"
									   :key="'agency_3_' + componentKey">
										{{ calculateAgency_3 | currency }}
									</p>
								</div>
							</div>

							<div v-if="inp.codice==='agenzia'"
							     class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_2"
									   :key="'agency_2_' + componentKey">
										{{ calculateAgency_2 | currency }}
									</p>
								</div>

							</div>
							<div v-if="inp.codice==='agenzia'"
							     class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_1"
									   :key="'agency_1_' + componentKey">
										{{ calculateAgency_1 | currency }}
									</p>
								</div>

							</div>
							<div v-if="inp.codice==='agenzia'"
							     class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<!-- <vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_4"
									             v-show="showColumn_4"></vue-numeric> -->

									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_4"
									   :key="'agency_4_' + componentKey">
										{{ calculateAgency_4 | currency }}
									</p>
								</div>

							</div>

							<!--------------------------------------->
							<!-- BLOCK 2  AGENZIA VENDITA -->
							<!-- ----------------------------------- -->
							<div class="col-3"
							     v-if="inp.codice==='agenzia_vendita'">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<div class="abtg__readonly_label">
										<strong class="abtg__readonly">{{$t('custom.label_agenzia_vendita')}}</strong>
										<popover module="custom"
										         content="incomefreeAgencySell"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</div>
								</div>
							</div>
							<div v-if="inp.codice==='agenzia_vendita'"
							     class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_3"
									   :key="'agency_sell_3_' + componentKey">
										{{ calculateAgencySell_3 | currency }}
									</p>
								</div>
							</div>

							<div v-if="inp.codice==='agenzia_vendita'"
							     class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_2"
									   :key="'agency_sell_2_' + componentKey">
										{{ calculateAgencySell_2 | currency }}
									</p>
								</div>

							</div>
							<div v-if="inp.codice==='agenzia_vendita'"
							     class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_1"
									   :key="'agency_sell_1_' + componentKey">
										{{ calculateAgencySell_1 | currency }}
									</p>
								</div>

							</div>
							<div v-if="inp.codice==='agenzia_vendita'"
							     class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<!-- <vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_4"
									             v-show="showColumn_4"></vue-numeric> -->

									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_4"
									   :key="'agency_sell_4_' + componentKey">
										{{ calculateAgencySell_4 | currency }}
									</p>
								</div>

							</div>

							<!--------------------------------------->
							<!-- BLOCK 1  TASSA REGISTRO -->
							<!-- ----------------------------------- -->
							<div class="col-3"
							     v-if="inp.codice==='tassa_registro'">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<div class="abtg__readonly_label">
										<strong class="abtg__readonly">{{$t('custom.label_tassa_registro')}}</strong>
										<popover module="custom"
										         content="incomefreeRegisterTax"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</div>
								</div>
							</div>

							<div v-if="inp.codice==='tassa_registro'"
							     class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_3">{{calculateTaxRegister_3 | currency}}
									</p>
								</div>

							</div>

							<div v-if="inp.codice==='tassa_registro'"
							     class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_2">{{calculateTaxRegister_2 | currency}}
									</p>
								</div>

							</div>
							<div v-if="inp.codice==='tassa_registro'"
							     class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_1">
										{{calculateTaxRegister_1 | currency}}
									</p>
								</div>

							</div>
							<div v-if="inp.codice==='tassa_registro'"
							     class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<!-- <vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_4"
									             v-show="showColumn_4"></vue-numeric> -->

									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_4">
										{{calculateTaxRegister_4 | currency}}
									</p>
								</div>

							</div>

						</div>

						<div class="row abtg__compact_row-custom  "
						     v-else>
							<div class="col-3">
								<!-- EDIT MODE SINGLE INPUT -->
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<input class="mdl-textfield__input abtg__input abtg__input-smalltext"
									       name="price"
									       type="text"
									       v-model="inp.etichetta"
									       placeholder="descrizione"
									       style="margin-top:6px;">
								</div>

							</div>
							<div class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_3"
									             v-show="showColumn_3"></vue-numeric>
								</div>

							</div>
							<div class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_2"
									             v-show="showColumn_2"></vue-numeric>
								</div>

							</div>

							<div class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_1"
									             v-show="showColumn_1"></vue-numeric>
								</div>

							</div>

							<div class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_4"
									             v-show="showColumn_4"></vue-numeric>
								</div>

							</div>
							<div class="col-1 text-left"
							     v-if="inp.ref === 0">
								<button class="mdl-button mdl-js-button mdl-button--icon abtg__icon-background abtg__icon-coloradd"
								        data-upgraded=",MaterialButton"
								        style="margin-top:0px; "
								        type="button"
								        @click="addInput(index, 1)">
									<i class="fas fa-plus"></i>
								</button>
								<button class="mdl-button mdl-js-button mdl-button--icon   abtg__icon-background abtg__icon-coloradd"
								        data-upgraded=",MaterialButton"
								        style="margin-top:0px;"
								        type="button"
								        v-if="inputs_1.length > 1 && inp.opzionale == 1 "
								        @click="removeInput(index, 1)">
									<i class="fas fa-minus"></i>
								</button>
							</div>
						</div>

						<div class="row abtg__compact_row-custom">
							<div class="col-3">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<div class="abtg__readonly_label">
										<strong class="abtg__readonly">{{$t('custom.label_costo_totale_acquisto')}}</strong>
										<popover module="custom"
										         content="incomefreeTotPurchase"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</div>
								</div>
							</div>
							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_3">{{ totPurchase(3, 1) | currency }}</p>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_2">{{ totPurchase(2, 1) | currency }}</p>
								</div>
							</div>

							<div class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_1">{{ totPurchase(1, 1) | currency }}</p>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<!-- <vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="formData.costi_4"
									             v-show="showColumn_4"></vue-numeric> -->

									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_4">{{ totPurchase(4, 1) | currency }}</p>
								</div>
							</div>
						</div>

						<!--------------------------------------->
						<!-- BLOCK 2 -->
						<!-- ----------------------------------- -->
						<div class="row">
							<div class="col">
								<div class="abtg__dotted_line"></div>
							</div>
						</div>
						<div class="row">
							<div class="col">
								<div class="abtg__paragraph_income">
									{{$t('custom.label_finanziamento')}}
								</div>
							</div>
						</div>
						<div class="row abtg__compact_row-custom  "
						     v-for="(inp,index) in filteredInput(2)"
						     v-if="inp.codice && inp.codice.length > 0 ">

							<!--------------------------------------->
							<!-- BLOCK 2  IMPOSTA SOSTITUTIVA -->
							<!--------------------------------------->
							<div class="col-3"
							     v-if="inp.codice==='impostaSostitutiva'">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<div class="abtg__readonly_label">
										<strong class="abtg__readonly">{{$t('custom.label_imposta_sostitutiva')}}</strong>
										<popover module="custom"
										         content="incomefreeSubstitutiveTax"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</div>
								</div>
							</div>
							<div v-if="inp.codice==='impostaSostitutiva'"
							     class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_3"
									   v-text="calculateSubstitutiveTax_3">
									</p>
								</div>

							</div>

							<div v-if="inp.codice==='impostaSostitutiva'"
							     class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_2"
									   v-text="calculateSubstitutiveTax_2">
									</p>
								</div>

							</div>
							<div v-if="inp.codice==='impostaSostitutiva'"
							     class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_1"
									   v-text="calculateSubstitutiveTax_1">
									</p>
								</div>

							</div>
							<div v-if="inp.codice==='impostaSostitutiva'"
							     class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<!--
									<vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_4"
									             v-show="showColumn_4"></vue-numeric> -->

									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_4"
									   v-text="calculateSubstitutiveTax_4">
									</p>
								</div>

							</div>
						</div>

						<div class="row"
						     v-else>
							<div class="col-3">
								<!-- EDIT MODE SINGLE INPUT -->
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<input class="mdl-textfield__input abtg__input abtg__input-smalltext"
									       name="price"
									       type="text"
									       v-model="inp.etichetta"
									       placeholder="descrizione"
									       style="margin-top:6px;">
								</div>

							</div>
							<div class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_3"
									             v-show="showColumn_3"></vue-numeric>
								</div>

							</div>

							<div class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_2"
									             v-show="showColumn_2"></vue-numeric>
								</div>

							</div>
							<div class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_1"
									             v-show="showColumn_1"></vue-numeric>
								</div>

							</div>
							<div class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_4"
									             v-show="showColumn_4"></vue-numeric>
								</div>

							</div>
							<div class="col-1 text-left">
								<button class="mdl-button mdl-js-button mdl-button--icon abtg__icon-background abtg__icon-coloradd"
								        data-upgraded=",MaterialButton"
								        style="margin-top:0px; "
								        type="button"
								        @click="addInput(index, 2)">
									<i class="fas fa-plus"></i>
								</button>
								<button class="mdl-button mdl-js-button mdl-button--icon   abtg__icon-background abtg__icon-coloradd"
								        data-upgraded=",MaterialButton"
								        style="margin-top:0px;"
								        type="button"
								        v-if="inputs_2.length > 1 && inp.opzionale === 1"
								        @click="removeInput(index, 2)">
									<i class="fas fa-minus"></i>
								</button>
							</div>
						</div>

						<!--------------------------------------->
						<!-- BLOCK 2  TOTALE COSTI FINANZIAMENTO -->
						<!-- ----------------------------------- -->
						<div class="row">
							<div class="col">
								<div class="abtg__dotted_line"></div>
							</div>
						</div>

						<div class="row abtg__compact_row-custom">
							<div class="col-3">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<div class="abtg__readonly_label">
										<strong class="abtg__readonly">{{$t('custom.label_totale_costi_finanziamento')}}</strong>
										<popover module="custom"
										         content="incomefreeTotalFinancingCost"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</div>
								</div>
							</div>
							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_3">{{ totFinancing(3, 2) | currency }}</p>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_2">{{ totFinancing(2, 2) | currency }}</p>
								</div>
							</div>
							<div class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_1">{{ totFinancing(1, 2) | currency }}</p>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<!-- <vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="formData.costi_4_totale_finanziamento"
									             v-show="showColumn_4"></vue-numeric> -->

									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_4">{{ totFinancing(4, 2) | currency }}</p>
								</div>
							</div>
						</div>

						<!--------------------------------------->
						<!-- BLOCK 2  TOTALE COSTI-->
						<!-- ----------------------------------- -->
						<div class="row abtg__compact_row-custom">
							<div class="col-3">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<div class="abtg__readonly_label">
										<strong class="abtg__readonly">{{$t('custom.label_totale_costi')}}</strong>
										<popover module="custom"
										         content="incomefreeTotalCost"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</div>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_3">{{ totCosts(3, 2) | currency }}</p>
								</div>
							</div>
							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_2">{{ totCosts(2, 2) | currency }}</p>
								</div>
							</div>

							<div class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_1">{{ totCosts(1, 2) | currency }}</p>
								</div>
							</div>
							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<!-- <vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="formData.costi_4_totale"
									             v-show="showColumn_4"></vue-numeric> -->

									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_4">{{ totCosts(4, 2) | currency }}</p>
								</div>
							</div>
						</div>

						<!--------------------------------------->
						<!-- BLOCK 2  COSTO TOTALE AL METRO QUADRO-->
						<!-- ----------------------------------- -->
						<div class="row abtg__compact_row-custom">
							<div class="col-3">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<div class="abtg__readonly_label">
										<strong class="abtg__readonly">{{$t('custom.label_totale_costi_mq')}}</strong>
										<popover module="custom"
										         content="incomefreeTotalCostMQ"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</div>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_3">{{ totCostsMq(3, 2) | currency }}</p>
								</div>
							</div>
							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_2">{{ totCostsMq(2, 2) | currency }}</p>
								</div>
							</div>
							<div class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_1">{{ totCostsMq(1, 2) | currency }}</p>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<!-- <vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="formData.costi_4_mq"
									             v-show="showColumn_4"></vue-numeric> -->

									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_4">{{ totCostsMq(4, 2) | currency }}</p>
								</div>
							</div>
						</div>

						<!--------------------------------------->
						<!-- BLOCK 2  COSTO TOTALE AL METRO QUADRO PER TASSE -->
						<!-- ----------------------------------- -->
						<div class="row abtg__compact_row-custom">
							<div class="col-3">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<div class="abtg__readonly_label">
										<strong class="abtg__readonly">{{$t('custom.label_totale_costi_mq_tasse')}}</strong>
										<popover module="custom"
										         content="incomefreeTotalCostMQTax"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</div>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_3">{{ totCostsMqTax(3, 2) | currency }}</p>
								</div>
							</div>
							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_2">{{ totCostsMqTax(2, 2) | currency }}</p>
								</div>
							</div>

							<div class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_1">{{ totCostsMqTax(1, 2) | currency }}</p>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<!-- <vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="formData.costi_4_mq_tasse"
									             v-show="showColumn_4"></vue-numeric> -->

									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_4">{{ totCostsMqTax(4, 2) | currency }}</p>
								</div>
							</div>
						</div>

						<!--------------------------------------->
						<!-- BLOCK 3  RICAVI -->
						<!-- ----------------------------------- -->
						<div class="row">
							<div class="col">
								<div class="abtg__dotted_line"></div>
							</div>
						</div>

						<div class="row">
							<div class="col">
								<div class="abtg__paragraph_income">
									{{$t('custom.label_ricavi')}}: € {{ mappedBuilding.street_price }})
								</div>
							</div>
						</div>
						<div class="row abtg__compact_row-custom"
						     v-for="(inp,index) in filteredInput(3)">
							<div class="col-3">
								<!-- EDIT MODE SINGLE INPUT -->
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<input class="mdl-textfield__input abtg__input abtg__input-smalltext"
									       name="price"
									       type="text"
									       v-model="inp.etichetta"
									       placeholder="descrizione"
									       style="margin-top:6px;">
								</div>

							</div>
							<div class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_3"
									             v-show="showColumn_3"></vue-numeric>
								</div>

							</div>
							<div class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_2"
									             v-show="showColumn_2"></vue-numeric>
								</div>

							</div>

							<div class="col-2">
								<!-- EDIT MODE SINGLE INPUT -->

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_1"
									             v-show="showColumn_1"></vue-numeric>
								</div>

							</div>
							<div class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="inp.importo_4"
									             v-show="showColumn_4"></vue-numeric>
								</div>

							</div>

						</div>

						<!--------------------------------------->
						<!-- BLOCK 3  RICAVI (MQ) -->
						<!-- ----------------------------------- -->
						<div class="row abtg__compact_row-custom">
							<div class="col-3">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<div class="abtg__readonly_label">
										<strong class="abtg__readonly">{{$t('custom.label_ricavi_mq')}}</strong>
									</div>
								</div>
							</div>
							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_3">{{ totRevenuesMq(3, 3) | currency }}</p>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_2">{{ totRevenuesMq(2, 3) | currency }}</p>
								</div>
							</div>

							<div class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_1">{{ totRevenuesMq(1, 3) | currency }}</p>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<!-- <vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="formData.ricavi_4_mq"
									             v-show="showColumn_4"></vue-numeric> -->

									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_4">{{ totRevenuesMq(4, 3) | currency }}</p>
								</div>
							</div>
						</div>

						<!--------------------------------------->
						<!-- BLOCK 3  UTILE LORDO -->
						<!-- ----------------------------------- -->
						<div class="row">
							<div class="col">&nbsp;</div>
						</div>
						<div class="row abtg__compact_row-custom">
							<div class="col-3">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<div class="abtg__readonly_label">
										<strong class="abtg__readonly">{{$t('custom.label_utile_lordo')}}</strong>
										<popover module="custom"
										         content="incomefreeGrossProfit"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</div>
								</div>
							</div>
							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_3">{{ totGrossProfit(3, 3) | currency }}</p>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_2">{{ totGrossProfit(2, 3) | currency }}</p>
								</div>
							</div>

							<div class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_1">{{ totGrossProfit(1, 3) | currency }}</p>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<!-- <vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="formData.utile_4_lordo"
									             v-show="showColumn_4"></vue-numeric> -->

									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_4">{{ totGrossProfit(4, 3) | currency }}</p>
								</div>
							</div>

						</div>

						<!--------------------------------------->
						<!-- BLOCK 3  Tassazione seconda casa  -->
						<!-- ----------------------------------- -->
						<div   class="row">
							<div class="col">
								<div class="abtg__dotted_line"></div>
							</div>
						</div>

						<div
                class="row">
							<div class="col">
								<div class="abtg__paragraph_income">
									{{$t('custom.label_tasse')}}
								</div>
							</div>
						</div>
						<div
                class="row abtg__compact_row-custom">
							<div class="col-3">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<div class="abtg__readonly_label">
										<strong class="abtg__readonly">{{$t('custom.label_totale_tasse')}}</strong>
										<popover module="custom"
										         content="incomefreeTotalTax"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</div>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_3">{{ totTax(3, 3) | currency }}</p>
								</div>
							</div>
							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
                     v-show="showColumn_2">{{ totTax(2, 3) | currency }}</p>
								</div>
							</div>

							<div class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
                     v-show="showColumn_1">{{ totTax(1, 3) | currency }}</p>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<!-- <vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="formData.totale_4_tasse"
									             v-show="showColumn_4"></vue-numeric> -->

									<p class="mdl-textfield__input abtg__input abtg__readonly"
                     v-show="showColumn_4">{{ totTax(4, 3) | currency }}</p>
								</div>
							</div>

						</div>

						<!--------------------------------------->
						<!-- BLOCK 3  Utile Netto-->
						<!-- ----------------------------------- -->
						<div class="row">
							<div class="col">
								<div class="abtg__dotted_line"></div>
							</div>
						</div>

						<div class="row">
							<div class="col">
								<div class="abtg__paragraph_income">
									{{$t('custom.label_utile')}}
								</div>
							</div>
						</div>
						<div class="row abtg__compact_row-custom">
							<div class="col-3">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<div class="abtg__readonly_label">
										<strong class="abtg__readonly">{{$t('custom.label_utile_netto')}}</strong>
										<popover module="custom"
										         content="incomefreeNetIncome"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</div>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_3">{{ totNetIncome(3, 3) | currency }}</p>
								</div>
							</div>
							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_2">{{ totNetIncome(2, 3) | currency }}</p>
								</div>
							</div>

							<div class="col-2">

								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">
									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_1">{{ totNetIncome(1, 3) | currency }}</p>
								</div>
							</div>

							<div class="col-2">
								<div class="mdl-js-textfield mdl-textfield--floating-label txt-width">

									<!-- <vue-numeric class="mdl-textfield__input abtg__input"
									             currency=""
									             separator="."
									             v-model="formData.utile_4_netto"
									             v-show="showColumn_4"></vue-numeric> -->

									<p class="mdl-textfield__input abtg__input abtg__readonly"
									   v-show="showColumn_4">{{ totNetIncome(4, 3) | currency }}</p>
								</div>
							</div>

						</div>

						<!--------------------------------------->
						<!-- BLOCK 3  Utile Netto-->
						<!-- ----------------------------------- -->
						<div class="row">
							<div class="col">
								<div class="abtg__dotted_line"></div>
							</div>
						</div>

						<!---------------------------------------->
						<!-- CAPITALE INVESTITO -->
						<!-- ------------------------------------ -->
						<div class="row abtg__compact_row-custom ">
							<div class="col-lg-3">{{$t('custom.label_capitale_proprio_investito')}}</div>
							<div class="col-lg-2">
								<vue-numeric class="mdl-textfield__input abtg__input"
								             currency=""
								             separator="."
								             v-model="personalInvestment.scenario_3"
								             v-show="showColumn_3"></vue-numeric>
							</div>
							<div class="col-lg-2">
								<vue-numeric class="mdl-textfield__input abtg__input"
								             currency=""
								             separator="."
								             v-model="personalInvestment.scenario_2"
								             v-show="showColumn_2"></vue-numeric>
							</div>

							<div class="col-lg-2">
								<vue-numeric class="mdl-textfield__input abtg__input"
								             currency=""
								             separator="."
								             v-model="personalInvestment.scenario_1"
								             v-show="showColumn_1"></vue-numeric>
							</div>

							<div class="col-lg-2">
								<vue-numeric class="mdl-textfield__input abtg__input"
								             currency=""
								             separator="."
								             v-model="personalInvestment.scenario_4"
								             v-show="showColumn_4"></vue-numeric>
							</div>
						</div>

						<div class="abtg__roiroewrapper_customFree">
							<div class="row">
								<div class="col-3">
									<p class="abtg__income-roi_roe">ROI
										<popover module="custom"
										         content="incomefreeROI"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</p>

								</div>
								<div class="col-2">
									<div class="abtg__custom-focus"
									     style=" "
									     v-show="showColumn_3">
										{{ roi(3) }} %
									</div>
								</div>
								<div class="col-2">

									<div class="abtg__custom-focus"
									     style=" "
									     v-show="showColumn_2">
										{{ roi(2) }} %
									</div>
								</div>

								<div class="col-2">

									<div class="abtg__custom-focus"
									     style=" "
									     v-show="showColumn_1">
										{{ roi(1) }} %
									</div>
								</div>

								<div class="col-2">
									<div class="abtg__custom-focus"
									     style=" "
									     v-show="showColumn_4">
										{{ roi(4) }} %
									</div>
								</div>

								<div class="col-1"></div>

							</div>
							<div class="row">
								<div class="col-3">
									<p class="abtg__income-roi_roe">ROE
										<popover module="custom"
										         content="incomefreeROE"
										         color="grey"
										         position="right"
										         iconType="simple"></popover>
									</p>
								</div>
								<div class="col-2">

									<div class="abtg__custom-focus"
									     style=" "
									     v-show="showColumn_3">
										{{ roe(3) }} %
									</div>

								</div>
								<div class="col-2">

									<div class="abtg__custom-focus"
									     style=" "
									     v-show="showColumn_2">
										{{ roe(2) }} %
									</div>

								</div>

								<div class="col-2">

									<div class="abtg__custom-focus"
									     style=" "
									     v-show="showColumn_1">
										{{ roe(1) }} %
									</div>

								</div>

								<div class="col-2">

									<div class="abtg__custom-focus"
									     style=" "
									     v-show="showColumn_4">
										{{ roe(4) }} %
									</div>

								</div>

								<div class="col-1"></div>
							</div>
						</div>

						<button type="submit"
						        class="  margin-right-10 btn-success float-right abtg__btn-star">{{$t('custom.bottone_salva_scheda_operazione')}}
						</button>

						<save-ok v-bind:content="{isItOk: saveOk}"></save-ok>

					</div>
				</form>
			</div>
		</div>
	</div>
</template>
<script>
	import { mixin } from '../../helpers/helper'

	import VueNumeric from 'vue-numeric'

	import { createHelpers } from 'vuex-map-fields'
	import { roles } from '../../helpers/roles'
	import modalConfigure from './modal_configure_customfree'
	import saveOk from '../commons/saveok'
	import Popover from '../commons/popover'
	import modalRating from '../commons/rating'
	import NDelete from '@/partials/modal_delete'

	const { mapFields } = createHelpers({
		getterType: 'customfree/getField',
		mutationType: 'customfree/updateField',
	})

	export default {
		mixins: [mixin, roles],
		props: ['id', 'type', 'customId'],
		components: { modalConfigure, saveOk, Popover, modalRating, VueNumeric, NDelete },
		data: function() {
			return {
				showColumn_1: true,
				showColumn_2: true,
				showColumn_3: true,
				showColumn_4: true,
				numero_casa: 1,
				price: 0,
				money: {
					decimal: ',',
					thousands: '.',
					prefix: '',
					suffix: '',
					precision: 0,
					masked: false,
				},
				componentKey: 0,
				estate_type: 1,
				estate_sell_type: 1,
			}
		},
		watch: {
			formDataLoaded(val) {
				if(val) {
					this.numero_casa = this.formData.numero_casa;
				}
			}
		},
		computed: {
			...mapFields([
				'inputs_1',
				'inputs_2',
				'inputs_3',
				'showModalConfigure',
				'formData',
				'mappedBuilding',
				'saveOk',
				'rating',
				'personalInvestment',
				'exportLink',
				'modalConfigureKey',
				'agency_val_1',
				'agency_val_2',
				'agency_val_3',
				'agency_val_4',
				'agency_sell_val_1',
				'agency_sell_val_2',
				'agency_sell_val_3',
				'agency_sell_val_4',
				'thisId',
				'isSaving',
				'formDataLoaded',
			]),

			getNumeroCasa: {
				set() {},
				get() {
					return this.numero_casa
				},
			},

			calculateTaxRegister_1: {
				set() {},
				get() {
					return this.calculateTaxRegister(1, this.getNumeroCasa) // block 1
				},
			},

			calculateTaxRegister_2: {
				set() {},
				get() {
					return this.calculateTaxRegister(2, this.getNumeroCasa) // block 1
				},
			},

			calculateTaxRegister_3: {
				set() {},
				get() {
					return this.calculateTaxRegister(3, this.getNumeroCasa) // block 1
				},
			},

			calculateTaxRegister_4: {
				set() {},
				get() {
					return this.calculateTaxRegister(4, this.getNumeroCasa) // block 1
				},
			},

			calculateAgency_1: {
				set() {},
				get() {
					return this.calculateAgency(1, 1) // block 1
				},
			},

			calculateAgency_2: {
				set() {},
				get() {
					return this.calculateAgency(2, 1) // block 1
				},
			},

			calculateAgency_3: {
				set() {},
				get() {
					return this.calculateAgency(3, 1) // block 1
				},
			},

			calculateAgency_4: {
				set() {},
				get() {
					return this.calculateAgency(4, 1) // block 1
				},
			},

			calculateAgencySell_1: {
				set() {},
				get() {
					return this.calculateAgencySell(1, 1) // block 1
				},
			},

			calculateAgencySell_2: {
				set() {},
				get() {
					return this.calculateAgencySell(2, 1) // block 1
				},
			},

			calculateAgencySell_3: {
				set() {},
				get() {
					return this.calculateAgencySell(3, 1) // block 1
				},
			},

			calculateAgencySell_4: {
				set() {},
				get() {
					return this.calculateAgencySell(4, 1) // block 1
				},
			},

			calculateSubstitutiveTax_1: {
				set() {},
				get() {
					return this.calculateSubstitutiveTax(1, 2) // block 2
				},
			},

			calculateSubstitutiveTax_2: {
				set() {},
				get() {
					return this.calculateSubstitutiveTax(2, 2) // block 2
				},
			},

			calculateSubstitutiveTax_3: {
				set() {},
				get() {
					return this.calculateSubstitutiveTax(3, 2) // block 2
				},
			},

			calculateSubstitutiveTax_4: {
				set() {},
				get() {
					return this.calculateSubstitutiveTax(4, 2) // block 2
				},
			},
		},

		created: function() {

			this.$store.dispatch('customfree/initCustomFree', {
				type: this.type,
				id: this.id,
				customId: this.customId,
			})

			// setTimeout(() => {
			// 	this.numero_casa = this.formData.numero_casa;
			// }, 2000)
		},

		methods: {
			totPurchase: function(number, blockNumber) {
				let inp = this.filteredInput(blockNumber)
				let myCost = inp.reduce(
					(sum, item) => sum + parseInt(mixin.methods.REMOVE_DOT(eval('item.importo_' + number))),
					0
				)
				let agency =
					this.estate_type === 1
						? this.calculateAgency(number, blockNumber)
						: eval('this.agency_val_' + number)
				let agency_sell =
					this.estate_sell_type === 1
						? this.calculateAgencySell(number, blockNumber)
						: eval('this.agency_sell_val_' + number)

				let c =
					parseInt(mixin.methods.REMOVE_DOT(myCost)) +
					agency +
					agency_sell +
					this.calculateTaxRegister(number, this.formData.numero_casa)
				return parseInt(mixin.methods.REMOVE_DOT(c))
			},

			totFinancing: function(number, blockNumber) {
				let inp = this.filteredInput(blockNumber)
				let withoutValoreFinanziario = inp.filter(function(item) {
					return item.ref !== 1
				})

				let myCost = withoutValoreFinanziario.reduce(
					(sum, item) => sum + parseInt(mixin.methods.REMOVE_DOT(eval('item.importo_' + number))),
					0
				)
				let costsSum =
					parseInt(mixin.methods.REMOVE_DOT(myCost)) +
					parseInt(mixin.methods.REMOVE_DOT(this.calculateSubstitutiveTax(number, blockNumber)))
				return costsSum
			},

			totCosts: function(number, blockNumber) {
				let myCost = this.totPurchase(number, 1) + this.totFinancing(number, blockNumber)
				return parseInt(mixin.methods.REMOVE_DOT(myCost))
			},

			totCostsMq: function(number, blockNumber) {
				return Math.round(
					this.totCosts(number, blockNumber) /
						parseInt(mixin.methods.REMOVE_DOT(this.mappedBuilding.mq))
				)
			},

			totCostsMqTax: function(number, blockNumber) {
				return Math.round(
					this.totPurchase(number, 1) / parseInt(mixin.methods.REMOVE_DOT(this.mappedBuilding.mq))
				)
			},

			totRevenuesMq: function(number, blockNumber) {
				let inp = this.filteredInput(blockNumber)
				let totalRevenue = inp.filter(function(item) {
					return item.ref === 1
				})

				if (totalRevenue.length > 0) {
					let v = eval('totalRevenue[0].importo_' + number)
					return Math.round(mixin.methods.REMOVE_DOT(v) / parseInt(this.mappedBuilding.mq))
				}
				return 0
			},

			totGrossProfit: function(number, blockNumber) {
				let inp = this.filteredInput(blockNumber)
				let totalRevenue = inp.filter(function(item) {
					return item.ref === 1
				})

				if (totalRevenue.length > 0) {
					let v = eval('totalRevenue[0].importo_' + number)
					return Math.round(
						mixin.methods.REMOVE_DOT(v) - mixin.methods.REMOVE_DOT(this.totCosts(number, 2))
					)
				}
				return 0
			},

			totTax: function(number, blockNumber) {
				let totTax= Math.round(
					parseInt(this.totGrossProfit(number, blockNumber)) *
						parseInt(eval('this.formData.percentage_tax_' + number)) /
						100
				)
        return this.formData.numero_casa===3 ? totTax * 0 : totTax
			},

			totNetIncome: function(number, blockNumber) {
				return Math.round(this.totGrossProfit(number, blockNumber) - this.totTax(number, blockNumber))
			},

			filteredInput: function(number) {
				this.estate_type = this.formData.estate_type
				this.estate_sell_type = this.formData.estate_sell_type
				let p = []
				switch (number) {
					case 1:
						p = this.inputs_1.filter(function(item) {
							return item.blocco === number
						})
						break
					case 2:
						p = this.inputs_2.filter(function(item) {
							return item.blocco === number
						})
						break
					case 3:
						p = this.inputs_3.filter(function(item) {
							return item.blocco === number
						})
						break
				}

				return p
			},

			showHideModalConfigure: function() {
				this.$store.commit('customfree/showModalConfigureSet')
				this.sendData('avoidRefresh');
			},

			calculateTaxRegister: function(number, houseNumber) {
				let v = 0
				let t = 0
        if(this.formData.cessione == 1) // se è una cessione questa tassa è sempre 0
        {
          return 0;
        }
				switch (parseInt(houseNumber)) {
					case 1:
						v = mixin.methods.REMOVE_DOT(eval('this.formData.rendita_catastale_1'))
						t = Math.round(mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(v) * 115.5 * 2 / 100)
						break
					case 2:
						v = mixin.methods.REMOVE_DOT(eval('this.formData.rendita_catastale_1'))
						t = Math.round(mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(v) * 126 * 9 / 100)
						break
					case 3:
						v = mixin.methods.REMOVE_DOT(eval('this.formData.rendita_catastale_' + number))
						let myValue = this.filteredInput(1).filter(function(item) {
							return item.ref === 1
						})
						let firstCostValue = eval('myValue[0].importo_' + number)
						t = Math.round(mixin.methods.REMOVE_DOT(firstCostValue) * (this.formData.percentuale_tassa_registro_1) / 100)
						break
				}

				return t > 1000 ? t : 1000
			},

			calculateAgency: function(number, blockNumber) {
				let myValue = this.filteredInput(blockNumber).filter(function(item) {
					return item.ref === 1
				})

				if (myValue.length > 0) {
					let v = eval('myValue[0].importo_' + number)

					if (this.estate_type === 1) {
						let p = eval('this.formData.percentage_estate_' + number)
						return Math.round(
							mixin.methods.REMOVE_DOT(v) * mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(p) / 100
						)
					} else if (this.estate_type === 2) {
						let p = parseInt(eval('this.formData.fixed_estate_' + number))
						this.$store.commit('customfree/setData', { data: p, name: 'agency_val_' + number })
						return eval('this.agency_val_' + number)
					}
				}

				return 0
			},

			calculateAgencySell: function(number, blockNumber) {
				let myValue = this.filteredInput(blockNumber).filter(function(item) {
					return item.ref === 1
				})

				if (myValue.length > 0) {
					let v = eval('myValue[0].importo_' + number)

					if (this.estate_sell_type === 1) {
						let p = eval('this.formData.percentage_estate_sell_' + number)
						return Math.round(
							mixin.methods.REMOVE_DOT(v) * mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(p) / 100
						)
					} else if (this.estate_sell_type === 2) {
						let p = parseInt(eval('this.formData.fixed_estate_sell_' + number))
						this.$store.commit('customfree/setData', { data: p, name: 'agency_sell_val_' + number })
						return eval('this.agency_sell_val_' + number)
					}
				}

				return 0
			},

			calculateSubstitutiveTax: function(number, blockNumber) {
				let myValue = this.filteredInput(blockNumber).filter(function(item) {
					return item.ref === 1
				})

				if (myValue.length > 0) {
					let v = eval('myValue[0].importo_' + number)
					let p = eval('this.formData.substitutiveTax_' + number)
					return Math.round(
						mixin.methods.REMOVE_DOT(v) * mixin.methods.REMOVE_DOT_AND_REPLACE_COMMA(p) / 100
					)
				}
				return 0
			},
			roi4: function() {
				let result = Math.round(
					mixin.methods.REMOVE_DOT(this.formData.utile_4_netto) /
						mixin.methods.REMOVE_DOT(this.formData.costi_4_totale) *
						100
				)
				if (isNaN(result)) {
					return '-'
				}
				this.$store.dispatch('custom/boxRoi', result, { root: true })
				return result
			},

			roe4: function() {
				let myValue = this.inputs_2.filter(function(item) {
					return item.ref === 1
				})
				if (myValue.length > 0) {
					// OLD FORMULA
					//let s = myValue[0].importo_4;
					//let result = Math.round(mixin.methods.REMOVE_DOT(this.formData.utile_4_netto) / (mixin.methods.REMOVE_DOT(this.formData.costi_4) - mixin.methods.REMOVE_DOT(s)) * 100);
					//this.$store.dispatch('custom/boxRoe', result, {root:true});
					//return result;
				}

				let s = this.personalInvestment.scenario_4
				let result = Math.round(
					mixin.methods.REMOVE_DOT(this.formData.utile_4_netto) / mixin.methods.REMOVE_DOT(s) * 100
				)

				this.$store.dispatch('custom/boxRoe', result, { root: true })
				return result
			},

			roi: function(number) {
				let result = Math.round(
					mixin.methods.REMOVE_DOT(this.totGrossProfit(number, 3)) /
						mixin.methods.REMOVE_DOT(this.totCosts(number, 2)) *
						100
				)
				if (isNaN(result)) {
					return '-'
				}
				return result
			},

			roe: function(number) {
				let myValue = this.inputs_2.filter(function(item) {
					return item.ref === 1
				})

				if (myValue.length > 0) {
					// OLD FORMULA
					//let s = eval('myValue[0].importo_' + number);
					//s = 0; // override
					//return Math.round(this.totNetIncome(number, 3) / ( this.totPurchase(number, 1)  - mixin.methods.REMOVE_DOT(s) )  * 100);
				}

				// NEW FORMULA
				let s = eval('this.personalInvestment.scenario_' + number)
				// let s = this.personalInvestment.scenario_1;
				return Math.round(this.totNetIncome(number, 3) / mixin.methods.REMOVE_DOT(s) * 100)
			},

			addInput: function(index, number) {
				switch (number) {
					case 1:
						this.inputs_1.splice(index + 1, 0, {
							importo_1: 0,
							importo_2: 0,
							importo_3: 0,
							importo_4: 0,
							etichetta: '',
							blocco: number,
							opzionale: 1,
							ref: 0,
							codice: '',
						})
						break
					case 2:
						this.inputs_2.splice(index + 1, 0, {
							importo_1: 0,
							importo_2: 0,
							importo_3: 0,
							importo_4: 0,
							etichetta: '',
							blocco: number,
							opzionale: 1,
							ref: 0,
							codice: '',
						})
						break
				}
			},

			removeInput: function(index, number) {
				switch (number) {
					case 1:
						this.inputs_1.splice(index, 1)
						break
					case 2:
						this.inputs_2.splice(index, 1)
						break
				}
			},

			sendData: function(what) {
				if (!this.isSaving) {
					if (what === 'export') {
						this.exportLink = '/operation/export/pdf/' + this.id + '/' + this.customId
					}

					if(what === 'avoidRefresh')
					{
						this.$store.commit('customfree/setData', { name: 'avoidRefresh', data: true })
					}
					this.$store.dispatch('customfree/sendData')
					this.$store.commit('customfree/setData', { name: 'isSaving', data: true })
				}
			},

			updateComponent: function(payload) {
				payload.estate_type ? (this.estate_type = payload.estate_type) : null
				payload.estate_sell_type ? (this.estate_sell_type = payload.estate_sell_type) : null
				payload.numero_casa ? (this.numero_casa = payload.numero_casa) : null
				this.calculateAgency(1, 1)
				this.calculateAgency(2, 1)
				this.calculateAgency(3, 1)
				this.calculateAgency(4, 1)
				this.calculateAgencySell(1, 1)
				this.calculateAgencySell(2, 1)
				this.calculateAgencySell(3, 1)
				this.calculateAgencySell(4, 1)
				this.componentKey++
			},

			showDeleteModal: function() {
				this.$store.commit('customfree/setData', { name: 'idToDelete', data: this.thisId })
				this.$modal.show('m-delete')
			},

			closeModal() {
				this.$store.commit('customfree/setData', { name: 'idToDelete', data: null })
				this.$modal.hide('m-delete')
			},

			deleteResource() {
				this.$store.dispatch('customfree/deleteCustom')
			},
		},
	}
</script>
